import { Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-validation-reasons-code-report-dw",
  templateUrl: "./validation-reasons-code-report-dw.component.html",
})
export class ValidationReasonsCodeReportDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.VALIDATION_REASON_CODE_REPORT_DW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.ORG_ID, HideFilters.USER_ID2];
}
